import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';

import './VettingCheckBoxPanel.css';
import CheckedLabel from '../Svg/CheckedLabel';
import UncheckedLabel from '../Svg/UncheckedLabel';

const VettingCheckBoxPanel = (props) => {
  const [isChecked, toggleChecked] = useState(false);

  useEffect(() => {
    toggleChecked(props.value);
  }, [props.value])

  return (
    <div className="vetting-checkbox-wrapper">
      {
        isChecked ?
          <div
            className="vetting-checkbox-label"
            onClick={() => {
              toggleChecked(!isChecked);
              props.onChange && props.onChange(!isChecked, props.inputIdentifier);
            }}
            automationid={`SalesLead_Div_${props.inputIdentifier}ChekedLabel_1`}
          >
            <CheckedLabel />
          </div>
          :
          <div
            className="vetting-checkbox-label"
            onClick={() => {
              toggleChecked(!isChecked);
              props.onChange && props.onChange(!isChecked, props.inputIdentifier);
            }}
            automationid={`SalesLead_Div_${props.inputIdentifier}UnchekedLabel_1`}
          >
            <UncheckedLabel />
          </div>
      }
      
      <input
        type="checkbox"
        value={props.value}
        name={props.label}
        automationid={`SalesLead_Input_${props.inputIdentifier}Input_1`}
      />
      <span 
        className="vetting-checkbox-label-wrapper"
        automationid={`SalesLead_Span_${props.inputIdentifier}InputLabel_1`}
        dangerouslySetInnerHTML={{ __html: props.label }}
      >
      </span>
    </div>
  );
}

VettingCheckBoxPanel.propTypes = {
  label: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func,
}

export default VettingCheckBoxPanel;
